import React, { useEffect, useState } from 'react';
import style from "./EditarPerfil.module.css";
import imgPerfil from "../../assests/imagenes/img_perfil.svg";
import { FaPowerOff } from "react-icons/fa";
import { IoMdCloseCircle } from "react-icons/io";
import { actualizarUsuario, obtenerPerfil } from "../../repositorios/apiServer";
import useStore from '../../useStore';
import HeaderVolver from "../HeaderVolver/HeaderVolver";
import { useNavigate } from "react-router-dom";

const EditarPerfil = () => {
  const navigate = useNavigate();
  const userToken = useStore(state => state.userToken);
  const setUserToken = useStore(state => state.setUserToken);

  const [userData, setUserData] = useState(null);
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [mensaje, setMensaje] = useState({ tipo: "", texto: "" });
  const [cargando, setCargando] = useState(false);
  const [perfilCargado, setPerfilCargado] = useState(false);
  const [errores, setErrores] = useState({
    nombre: false,
    email: false
  });

  useEffect(() => {
    const cargarPerfil = async () => {
      if (userToken && !perfilCargado) {
        try {
          setCargando(true);

          const perfilData = await obtenerPerfil();

          if (perfilData && perfilData.user) {
            const usuario = perfilData.user;
            setUserData(usuario);
            setNombre(usuario.nombre || "");
            setEmail(usuario.email || "");
            setPerfilCargado(true);
          }
        } catch (error) {
          console.error("Error al cargar perfil:", error);
          setMensaje({
            tipo: "error",
            texto: "Error al cargar datos del perfil"
          });
        } finally {
          setCargando(false);
        }
      } else if (!userToken) {
        navigate("/login");
      }
    };

    if (userToken || !perfilCargado) {
      cargarPerfil();
    }
  }, [userToken, perfilCargado, navigate]);

  function handleCambioNombre(e) {
    const { value } = e.target;
    setNombre(value);

    setErrores({
      ...errores,
      nombre: value.trim().length === 0 && value.length > 0
    });
  }

  function handleCambioEmail(e) {
    const { value } = e.target;
    setEmail(value);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setErrores({
      ...errores,
      email: !emailRegex.test(value) && value.length > 0
    });
  }

  function handleCambioPass(e) {
    const { value } = e.target;
    setPass(value);
  }

  const cerrarSesion = () => {
    setUserToken(null);
    navigate("/login");
  };

  const volverAlMenu = () => {
    navigate("/carta");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!nombre || !email) {
      setMensaje({
        tipo: "error",
        texto: "Por favor completa todos los campos"
      });
      return;
    }

    if (nombre.trim().length === 0) {
      setMensaje({
        tipo: "error",
        texto: "Por favor ingresa tu nombre"
      });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMensaje({
        tipo: "error",
        texto: "Por favor ingresa un correo electrónico válido"
      });
      return;
    }

    setCargando(true);
    setMensaje({ tipo: "", texto: "" });

    try {
      const userId = userData ? (userData.id || userData._id) : null;

      if (!userId) {
        throw new Error("No se pudo obtener el ID del usuario");
      }

      const usuarioActualizado = await actualizarUsuario({
        id: userId,
        nombre,
        email,
        pass
      });

      if (usuarioActualizado) {
        setUserData({
          ...userData,
          nombre,
          email
        });

        setMensaje({
          tipo: "exito",
          texto: "Perfil actualizado con éxito"
        });
      } else {
        setMensaje({
          tipo: "error",
          texto: "Error al actualizar el perfil"
        });
      }
    } catch (error) {
      console.error("Error en la actualización:", error);
      setMensaje({
        tipo: "error",
        texto: "Error al actualizar el perfil. Por favor intenta de nuevo."
      });
    } finally {
      setCargando(false);
    }
  };

  if (!userToken) {
    navigate("/login");
    return null;
  }

  return (
    <div className={style.contenedor}>
      <div className={style.header_contenedor}>
        <div className={style.header_left}>
          <HeaderVolver
            tituloPrincipal="Editar los datos"
            tituloDestacado="DE MI PERFIL"
          />
        </div>
        <div className={style.boton_volver} onClick={volverAlMenu}>
          <IoMdCloseCircle className={style.icono_volver} />
          <span className={style.texto_volver}>Volver a menú</span>
        </div>
      </div>

      <div className={style.favoritos_content}>
        <div>
          <img
            src={imgPerfil}
            alt="imagen de perfil"
            className={style.imgPerfil}
          />
        </div>

        {mensaje.texto && (
          <div className={style.mensaje} style={{
            color: mensaje.tipo === "error" ? "#f44336" : "#4caf50"
          }}>
            {mensaje.texto}
          </div>
        )}

        {cargando && !perfilCargado ? (
          <div className={style.loading}>Cargando datos del perfil...</div>
        ) : (
          <form onSubmit={handleSubmit} className={style.formPerfil}>
            <div className={style.campoPerfil}>
              <label>Nombre</label>
              <input
                type="text"
                name="nombre"
                value={nombre}
                placeholder="Tu nombre"
                onChange={handleCambioNombre}
                style={errores.nombre ? { borderColor: '#f44336' } : {}}
              />
              {errores.nombre &&
                <div style={{ color: '#f44336', fontSize: '0.8rem', marginTop: '5px' }}>
                  Ingresa tu nombre
                </div>
              }
            </div>

            <div className={style.campoPerfil}>
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={email}
                placeholder="correo@ejemplo.com"
                onChange={handleCambioEmail}
                style={errores.email ? { borderColor: '#f44336' } : {}}
              />
              {errores.email &&
                <div style={{ color: '#f44336', fontSize: '0.8rem', marginTop: '5px' }}>
                  Ingresa un correo electrónico válido (debe contener @ y .)
                </div>
              }
            </div>

            <div className={style.campoPerfil}>
              <label>Contraseña</label>
              <input
                type="password"
                value={pass}
                name="pass"
                placeholder="••••••••••••••••••••"
                onChange={handleCambioPass}
              />
            </div>

            <button
              className={style.buttonForm}
              type="submit"
              disabled={cargando || errores.nombre || errores.email}
            >
              {cargando ? "Guardando..." : "Guardar cambios."}
            </button>
          </form>
        )}

        <div className={style.footer_container}>
          <div className={style.cerrarSesion} onClick={cerrarSesion}>
            <FaPowerOff className={style.iconOff} />
            <p>Cerrar sesión</p>
          </div>

          <div className={style.politicas}>
            <span className={style.textPoliticas}>
              Política de privacidad y gestión de datos.
            </span>
            <span className={style.textPoliticas}>
              Número de atención al cliente La Romana
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditarPerfil;